import { StarsButton } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import type { TableInstance } from 'react-table';

import Slider from '@swf/components/Slider/Slider';
import type { SliderHandles, State as SliderState } from '@swf/components/Slider/Slider';
import type { Dispatch } from '@swf/core/store';
import { PokerSliderHandles, useIsMobileDevice } from '@swf/poker';

import { ModalRoutes } from '../../../../types/common';
import useActionButtons from '../hooks/useActionButtons';
import styles from '../shared.scss';
import { MemberStatusesPerPage } from '../utils';

import {
  TXTCLI_Block,
  TXTCLI_Edit,
  TXTCLI_Grant_Admin,
  TXTCLI_Reinstate,
  TXTCLI_Remove,
  TXTCLI_Revoke_Admin,
  TXTCLI_Suspend
} from './ActionButtons.messages.json';

const ActionButtons: React.FC<{ tableInstance: TableInstance<object> }> = ({ tableInstance }) => {
  const { disabled, handleClick } = useActionButtons({
    tableInstance,
    callbackStatuses: MemberStatusesPerPage.Approved,
    memberType: 'approved'
  });
  const sliderRef = React.createRef<SliderHandles>();
  const { modal } = useDispatch<Dispatch>();
  const isMobileDevice = useIsMobileDevice();
  const [sliderState, setSliderState] = useState<SliderState>({ left: false, right: false });

  if (isMobileDevice) {
    return (
      <div className={classNames(styles.mobileButtons, { [styles.hidden]: disabled })}>
        <StarsButton
          translation={TXTCLI_Edit}
          onClick={() =>
            modal.enqueue({
              path: ModalRoutes.membersAdminActions,
              locationState: { handleClick }
            })
          }
        />
      </div>
    );
  }

  const showButtons = !disabled && (sliderState.left || sliderState.right);

  return (
    <Slider
      className={classNames({ [styles.hidden]: disabled })}
      innerClassName={styles.actionButtons}
      ref={sliderRef}
      onScroll={setSliderState}
    >
      {showButtons && <PokerSliderHandles sliderRef={sliderRef} sliderState={sliderState} />}
      <StarsButton
        className={styles.tertiaryButton}
        disabled={disabled}
        data-action="HG_REMOVE_PLAYER"
        variant="tertiary"
        size="small"
        translation={TXTCLI_Remove}
        onClick={handleClick}
      />
      <StarsButton
        className={styles.tertiaryButton}
        disabled={disabled}
        data-action="HG_MAKE_PLAYER_ADMIN"
        variant="tertiary"
        size="small"
        translation={TXTCLI_Grant_Admin}
        onClick={handleClick}
      />
      <StarsButton
        className={styles.tertiaryButton}
        disabled={disabled}
        data-action="HG_REVOKE_PLAYER_ADMIN"
        variant="tertiary"
        size="small"
        translation={TXTCLI_Revoke_Admin}
        onClick={handleClick}
      />
      <StarsButton
        className={styles.tertiaryButton}
        disabled={disabled}
        data-action="HG_SUSPEND_PLAYER"
        variant="tertiary"
        size="small"
        translation={TXTCLI_Suspend}
        onClick={handleClick}
      />
      <StarsButton
        className={styles.tertiaryButton}
        disabled={disabled}
        data-action="HG_BLOCK_PLAYER"
        variant="tertiary"
        size="small"
        translation={TXTCLI_Block}
        onClick={handleClick}
      />
      <StarsButton
        className={styles.tertiaryButton}
        disabled={disabled}
        data-action="HG_REINSTATE_PLAYER"
        variant="tertiary"
        size="small"
        translation={TXTCLI_Reinstate}
        onClick={handleClick}
      />
    </Slider>
  );
};

export default ActionButtons;
